// This file is auto-generated by @hey-api/openapi-ts
import { formDataBodySerializer } from './client';
import { client } from './client.gen';
export class AgentRunnerService {
    /**
     * Send requests to LLM
     */
    static execute(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/reasoner',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Send requests to LLM from pathways neuron
     *
     * Initiates reasoner request and returns response to callback url
     */
    static executeNeuron(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/reasoner/neuron',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Initiates a new context for an agent
     */
    static initRunnerContext(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/reasoner/contexts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Execute agent
     *
     * Initiates reasoner request for a single agent
     */
    static executeSingleAgent(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/reasoner/{agentId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Run an agent with stream capabilities
     */
    static runAgentWithStream(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/reasoner/contexts/{contextId}/message',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ContextsService {
    /**
     * Get suggestions for an agent, optionally based on conversation history
     */
    static getSuggestions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/suggestions',
            ...options
        });
    }
    /**
     * Get contexts for current user with pagination
     */
    static getContexts(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts',
            ...options
        });
    }
    /**
     * Get context by ID
     */
    static getContext(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}',
            ...options
        });
    }
    /**
     * The tool calls a paused turn is waiting on
     *
     * Answer them by sending `approvals` to the message endpoint, with `answers` for a question. Empty unless the last turn paused on a tool that needs approval or asked one.
     */
    static getPendingApprovals(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/pending-approvals',
            ...options
        });
    }
    /**
     * Get exchanges for given context
     */
    static getExchanges(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/exchanges',
            ...options
        });
    }
    /**
     * Get execution context by ID
     */
    static getExchange(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/exchanges/{exchangeId}',
            ...options
        });
    }
    /**
     * Get agent usage statistics for given contexts
     */
    static getAgentUsage(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/agent-usage',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update context metadata (title, accessedAt)
     */
    static updateMetadata(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/metadata',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Generate a title for the context based on a prompt
     */
    static generateTitle(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/generate-title',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Summarize the conversation now
     *
     * The agent then sees the summary instead of the messages it covers, and can read them back. Answers the latest summary unchanged when nothing came after it.
     */
    static compact(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/actions/compact',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Where the conversation was summarized, newest first
     */
    static getSummaries(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/summaries',
            ...options
        });
    }
    /**
     * What the conversation keeps by key, newest first, without the values
     */
    static listDataEntries(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/data-entries',
            ...options
        });
    }
    /**
     * One kept entry with its value
     */
    static getDataEntry(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/data-entries/{key}',
            ...options
        });
    }
}
export class AgentOverridesService {
    /**
     * Retrieve all overrides for an agent
     */
    static getAllOverridesForAgent(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{agentId}/overrides',
            ...options
        });
    }
    /**
     * Creates an agent override
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{agentId}/overrides',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Updates an agent override
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{agentId}/overrides',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete an agent override
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{agentId}/overrides/{id}',
            ...options
        });
    }
    /**
     * Retrieve an agent override
     */
    static getOverrideForAgent(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{agentId}/overrides/{id}',
            ...options
        });
    }
}
export class AgentsService {
    /**
     * Get all available agents
     */
    static getAllAgents(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents',
            ...options
        });
    }
    /**
     * Get agents by array of IDs
     */
    static getAgentsByIds(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/by-ids',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get most used agents for the current user
     *
     * Returns agents ranked by usage score (messageCount + contextCount). If fewer agents are found than the requested limit, remaining slots are filled with other allowed agents.
     */
    static getMostUsedAgents(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/most-used',
            ...options
        });
    }
    /**
     * List the current user’s tool shortcuts in the selected workspace
     */
    static listShortcuts(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/shortcuts',
            ...options
        });
    }
    /**
     * Clear a shortcut slot for the current user/workspace
     */
    static deleteShortcut(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/shortcuts/{slotIndex}',
            ...options
        });
    }
    /**
     * Assign an agent to a shortcut slot for the current user/workspace
     */
    static upsertShortcut(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/shortcuts/{slotIndex}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get agent by ID
     */
    static getAgentById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{id}',
            ...options
        });
    }
    /**
     * Get an agent's display profile
     *
     * Name, avatar, tag and placeholder of an agent, also for a caller without its open permission, so a past chat with it can still show whose it is. 404 wherever `GET /agents/:id` would 404 for any other reason.
     */
    static getAgentProfile(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/{id}/profile',
            ...options
        });
    }
    /**
     * Automatically setup default tool context data for required agents and tools
     */
    static defaultSetup(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/default-setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class AccessControlService {
    /**
     * Get access control overview for all agents in an organization
     *
     * Returns per-agent access mode and affected workspaces. Agents without an ACL are available everywhere (mode=all).
     */
    static getAgentsAvailableTo(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/access-control/available',
            ...options
        });
    }
    /**
     * Check if an agent is allowed for specified organization and workspace
     *
     * False when the workspace's ACL excludes the agent, or when the caller lacks the agent's open permission.
     */
    static isAgentAllowed(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/access-control/{agentId}/allowed',
            ...options
        });
    }
    /**
     * Set access mode and workspaces for an agent
     *
     * Sets the agent to "only" (whitelist) or "except" (blacklist) mode with specific workspaces.
     */
    static setAgentAccess(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/access-control/set',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Reset access override for an agent, returning it to org default (available everywhere)
     */
    static resetAgentAccess(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/access-control/{agentId}',
            ...options
        });
    }
}
export class ArtifactsService {
    /**
     * Get all versions of an artifact
     */
    static getArtifactVersions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/artifacts/{key}/versions',
            ...options
        });
    }
    /**
     * Get a specific version of an artifact
     */
    static getArtifactVersion(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/artifacts/{key}/versions/{version}',
            ...options
        });
    }
    /**
     * Create a new version of an existing artifact
     */
    static createNewVersion(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/contexts/{contextId}/artifacts/versions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List the caller's artifacts across a workspace
     */
    static listForWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/{workspaceId}/artifacts',
            ...options
        });
    }
    /**
     * Resolve full data for many artifact versions in one call
     *
     * Batched form of GET /contexts/:contextId/artifacts/:key/versions/:version. Carries the same per-version capability semantics — each tuple is resolved exactly as the single route would resolve it. Tuples that match no artifact are omitted; results preserve request order.
     */
    static batchDetail(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/{workspaceId}/artifacts/batch-detail',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get a single workspace artifact (including its data) by id
     *
     * Resolves one artifact within a workspace, applying the same visibility rules as the list endpoint. Returns the full data payload so callers can render a self-contained snapshot.
     */
    static getWorkspaceArtifactById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/{workspaceId}/artifacts/{artifactId}',
            ...options
        });
    }
    /**
     * Save a widget as a workspace artifact
     *
     * Generic, registry-driven save: the caller sends the live widget artifact id (+ opaque per-kind options); the backend resolves the content server-side (mirrors the opportunity save) and mints a context-less artifact. The key is derived per kind from stable inputs (e.g. strategy: exchangeId + territory index), so it is idempotent — re-saving the same item refreshes the one row while distinct items produce distinct artifacts. `:kind` selects the registered widget (e.g. strategic-territories).
     */
    static saveWidgetArtifact(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/{workspaceId}/artifacts/save/{kind}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Save a generated file as a workspace artifact
     *
     * Mints a context-less FILE artifact from a generated asset (id + display metadata sent by the client). Keyed by the asset id, so re-saving the same file refreshes the one row. Used by the translation agent to save its output spreadsheet to a project Library.
     */
    static saveFileArtifact(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/{workspaceId}/artifacts/save-file',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ArtifactExportsService {
    /**
     * Render an artifact to a PDF (server-rendered, headless Chromium)
     *
     * Renders the artifact via its standalone `/download/:documentType/:id` print page in headless Chromium and streams a single tall-page PDF. `documentType` selects the print page; `itemIndex` picks one item from a collection-backed artifact (e.g. one territory).
     */
    static exportPdfV2(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports/pdf',
            ...options
        });
    }
    /**
     * Get all exports for an artifact
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports',
            ...options
        });
    }
    /**
     * Create a new export for an artifact
     *
     * Initiates an export operation for the specified artifact. The export is processed asynchronously. Use the status endpoint to check progress.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get the last export for an artifact
     */
    static getLast(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports/last',
            ...options
        });
    }
    /**
     * Get a specific artifact export
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports/{exportId}',
            ...options
        });
    }
    /**
     * Get the status of an artifact export
     *
     * Retrieves the current status of an export operation. Refreshes it from the export strategy and updates the local status if changed.
     */
    static getStatus(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports/{exportId}/status',
            ...options
        });
    }
    /**
     * Get the asset for an artifact export
     *
     * Retrieves the exported asset file with a signed URL. If not yet cached, fetches it from the export strategy and uploads it to storage.
     */
    static getAsset(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/exports/{exportId}/asset',
            ...options
        });
    }
}
export class ObjectExportsService {
    /**
     * Create a new object export
     *
     * Creates an export for a generic object payload.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/exports',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get the status of an object export
     */
    static getStatus(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/exports/status',
            ...options
        });
    }
    /**
     * Get the asset for a completed object export
     */
    static getAsset(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/exports/asset',
            ...options
        });
    }
}
export class OpportunitiesService {
    /**
     * Clear opportunities in a workspace
     *
     * Permanently deletes opportunities for the specified workspace. Optionally filter by date range (dateStart and/or dateEnd). Omit date parameters to delete all opportunities. Requires the platform:manage-tools permission and workspace write access.
     */
    static clearWorkspaceOpportunities(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities',
            ...options
        });
    }
    /**
     * Get opportunities
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities',
            ...options
        });
    }
    /**
     * Remove favorite for the current user
     */
    static unfavorite(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}/favorite',
            ...options
        });
    }
    /**
     * Mark an opportunity as favorite for the current user
     */
    static favorite(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}/favorite',
            ...options
        });
    }
    /**
     * Remove the current user's feedback on an opportunity
     */
    static removeFeedback(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}/feedback',
            ...options
        });
    }
    /**
     * Create or replace the current user's feedback on an opportunity
     *
     * A full replace: fields left out are cleared, so switching to a like drops the reasons.
     */
    static setFeedback(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}/feedback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get opportunity run schedule for current organization
     */
    static getSchedule(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/schedule',
            ...options
        });
    }
    /**
     * Update opportunity run schedule for current organization
     */
    static updateSchedule(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/schedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List opportunity run schedules per workspace for the current organization
     *
     * Each entry is the schedule that actually applies to the workspace: its own override when set, otherwise the organization schedule.
     */
    static listSchedules(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/schedules',
            ...options
        });
    }
    /**
     * Remove a workspace schedule override so it inherits the organization schedule
     */
    static removeWorkspaceSchedule(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/schedules/{workspaceId}',
            ...options
        });
    }
    /**
     * Override the opportunity run schedule for a single workspace
     */
    static updateWorkspaceSchedule(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/schedules/{workspaceId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get aggregate KPI stats for the Opportunities Room
     *
     * Returns total, new-since-`since`, and count-by-duration-type computed in SQL, so the client never has to page the whole table to render KPI counters.
     */
    static getStats(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/stats',
            ...options
        });
    }
    /**
     * Preview how many opportunities a matching clear would delete
     *
     * Returns the exact number of opportunities that the DELETE /opportunities endpoint would remove for the same (workspaceId, dateStart, dateEnd). Does NOT apply the discovery-time duration-based expiration filter, so it stays consistent with the destructive path. Requires workspace admin permission.
     */
    static getWorkspaceClearCount(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/workspace-clear-count',
            ...options
        });
    }
    /**
     * Get a single opportunity by id
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}',
            ...options
        });
    }
    /**
     * Download an opportunity as a PDF
     *
     * Renders the standalone opportunity print page in headless Chromium and returns it as a single tall-page PDF (selectable text, clickable links). `workspaceId` selects the workspace for the headless render.
     */
    static downloadPdf(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}/pdf',
            ...options
        });
    }
    /**
     * Save an opportunity to the workspace as a rich artifact
     *
     * Mints (idempotently) a context-less social_opportunities artifact that references the opportunity by id. All artifact fields are derived server-side from the opportunity; the caller only supplies the opportunity id. Used by "Save Opportunity to Project".
     */
    static saveAsArtifact(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/opportunities/{opportunityId}/artifact',
            ...options
        });
    }
}
export class ModelProvidersService {
    /**
     * Get all available model providers
     *
     * Returns a list of all model providers
     */
    static getAllProviders(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/model-providers',
            ...options
        });
    }
    /**
     * Get whitelisted model providers for an organization
     *
     * Returns the list of whitelisted model providers for the current user's organization
     */
    static getWhitelist(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/model-providers/whitelist',
            ...options
        });
    }
    /**
     * Update model provider whitelist for an organization or workspace
     *
     * Replaces all whitelisted model providers for an organization or workspace
     */
    static updateWhitelist(options) {
        return (options.client ?? client).put({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/model-providers/whitelist',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CustomWorkflowsService {
    /**
     * Lists all custom workflows for a workspace
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/custom-workflows',
            ...options
        });
    }
    /**
     * Creates a new custom workflow
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/custom-workflows',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Deletes a specific custom workflow by ID
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/custom-workflows/{id}',
            ...options
        });
    }
    /**
     * Gets a specific custom workflow by ID
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/custom-workflows/{id}',
            ...options
        });
    }
    /**
     * Gets a specific custom workflow by ID with fields
     */
    static getByIdWithFields(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/custom-workflows/{id}/fields',
            ...options
        });
    }
}
export class TemplatePublishWorkflowsService {
    /**
     * Lists publish workflows for a workspace + agent
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/template-publish-workflows',
            ...options
        });
    }
    /**
     * Registers a pipeline as a publish target for an agent
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/template-publish-workflows',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Deletes a publish workflow by ID
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/template-publish-workflows/{id}',
            ...options
        });
    }
    /**
     * Publishes an artifact to all registered pipelines for a workspace + agent
     */
    static publish(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/template-publish-workflows/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class EtlService {
    /**
     * Delete a content source
     */
    static deleteContentSource(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/content-source',
            ...options
        });
    }
    /**
     * Get known content sources
     */
    static getContentSources(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/content-source',
            ...options
        });
    }
    /**
     * Add a new content source
     */
    static addContentSource(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/content-source',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update content source's domains
     */
    static updateContentSource(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/content-source',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class AudienceService {
    /**
     * Download a persona as a PDF
     *
     * Renders the standalone persona print page in headless Chromium and returns it as a single tall-page PDF (selectable text). `workspaceId` selects the workspace for the headless render.
     */
    static downloadPdf(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/{id}/pdf',
            ...options
        });
    }
    /**
     * Generates an audience spark for a persona
     */
    static generateAudienceSpark(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/{id}/spark',
            ...options
        });
    }
    /**
     * Generates an audience asset for a persona and updates it
     */
    static generateAudienceAsset(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/{id}/asset',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Starts background audience persona creation. Creates a processing stub synchronously, dispatches the persona manager agent in the background, and returns 202 with status `processing` — poll persona-api for completion.
     */
    static createAudiencePersona(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/create',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Updates an audience persona, refreshing GWI stats when the GWI link changes
     */
    static updateAudiencePersona(options) {
        return (options.client ?? client).put({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Gets the workspaces an audience persona is shared with
     */
    static getAudiencePersonaWorkspaces(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/{id}/workspaces',
            ...options
        });
    }
    /**
     * Shares or unshares an audience persona across workspaces of its own organization
     */
    static updateAudiencePersonaWorkspaces(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience/{id}/workspaces',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class EtlJobsService {
    /**
     * Get the list of ETL jobs
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/jobs',
            ...options
        });
    }
    /**
     * Create a new ETL job
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/jobs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete an ETL job
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/jobs/{id}',
            ...options
        });
    }
    /**
     * Get a specific ETL job
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/jobs/{id}',
            ...options
        });
    }
    /**
     * Modify an existing ETL job
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/jobs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Report which workspaces are configured for Deep Research opportunities
     *
     * Answers the question the scheduler asks before queueing a run. A workspace is configured when every configurable tool of the Deep Research agent has context data at workspace or organization scope.
     */
    static getConfigurationStatus(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/etl/jobs/configuration-status',
            ...options
        });
    }
}
export class ToolsService {
    /**
     * List available MCP servers
     */
    static listMcpServers(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/mcp-servers',
            ...options
        });
    }
    /**
     * List all available tools
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools',
            ...options
        });
    }
    /**
     * Get tool details
     */
    static getByName(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{name}',
            ...options
        });
    }
}
export class McpCatalogService {
    /**
     * List catalog MCP servers visible to the caller (any authenticated user)
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-catalog',
            ...options
        });
    }
    /**
     * Add an MCP server to the catalog (admin)
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-catalog',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Remove an MCP server from the catalog (admin)
     */
    static remove(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-catalog/{id}',
            ...options
        });
    }
    /**
     * Update a catalog MCP server (admin)
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-catalog/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class UserMcpServersService {
    /**
     * Install a catalog MCP for the current user
     */
    static install(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}/install',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Start the OAuth authorization for a catalog OAuth MCP
     */
    static connect(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}/connect',
            ...options
        });
    }
    /**
     * Complete an OAuth authorization the current user started
     */
    static completeOAuthConnect(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/oauth/complete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List the current user's installed MCPs
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers',
            ...options
        });
    }
    /**
     * Test the live connection to an installed MCP
     */
    static test(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}/test',
            ...options
        });
    }
    /**
     * Discover the tools an installed MCP exposes
     */
    static discoverTools(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}/tools',
            ...options
        });
    }
    /**
     * Set which tools are disabled for an installed MCP
     */
    static setDisabledTools(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}/tools',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Uninstall an MCP
     */
    static uninstall(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}',
            ...options
        });
    }
    /**
     * Replace the stored credentials for an installed MCP
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mcp-servers/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class AgentConfigurationService {
    /**
     * Get JSON schemas for all configurable tools
     */
    static getToolSchemas(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agents/configuration/schemas',
            ...options
        });
    }
}
export class ToolContextDataService {
    /**
     * Batch upsert tool context data
     */
    static batchUpsert(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-context-data',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get all tool context data configs across scope levels
     */
    static findAllByToolId(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-context-data/tool/{toolId}/all',
            ...options
        });
    }
    /**
     * Delete tool context data by tool ID and organization or workspace ID
     */
    static deleteByToolId(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-context-data/tool/{toolId}',
            ...options
        });
    }
    /**
     * Get tool context data by tool ID and organization or workspace ID
     */
    static findByToolId(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-context-data/tool/{toolId}',
            ...options
        });
    }
}
export class AnalysisService {
    /**
     * List analysis sessions
     *
     * Returns all analysis sessions for the current workspace, ordered by newest first.
     */
    static listSessions(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis',
            ...options
        });
    }
    /**
     * Start a new analysis session
     *
     * Creates an analysis session, persists it in the database, and starts background analysis. Returns the session ID and status immediately for polling.
     */
    static createAnalysis(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get analysis status
     *
     * Returns lightweight status response for polling UI progress indicators.
     */
    static getAnalysisStatus(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/status',
            ...options
        });
    }
    /**
     * List the file-upload data sources and their activation state
     *
     * One entry per source whose feature flag is on for the caller, each carrying whether this workspace has activated it. A source that is off is still listed, so the Knowledge surface can offer it for connection.
     */
    static listDataSources(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/data-sources',
            ...options
        });
    }
    /**
     * Activate or deactivate a data source for the selected workspace
     *
     * Requires the source's own integration permission. Deactivating leaves data already attached to existing reports in place; it only stops new files being attached.
     */
    static updateDataSource(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/data-sources/{source}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Download the sample spreadsheet a file for this source has to match
     *
     * The parser rejects a file whose columns don't match, so the template is the contract. It is generated from the same column table the parser matches on, and a test runs it back through the real parser.
     */
    static downloadDataSourceTemplate(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/data-sources/{source}/template',
            ...options
        });
    }
    /**
     * Delete an analysis
     *
     * Permanently deletes a failed or completed analysis session.
     */
    static deleteAnalysis(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}',
            ...options
        });
    }
    /**
     * Get analysis results
     *
     * Returns the complete analysis session including report, citations, and action items.
     */
    static getAnalysis(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}',
            ...options
        });
    }
    /**
     * Get the Category and Competition Statista datasets for an analysis
     *
     * Returns the Block B (Category and Competition) Statista datasets stored against this analysis, with their chart image URLs. An analysis with no datasets returns an empty `data` array rather than a 404.
     */
    static getStatistaDatasets(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/statista-datasets',
            ...options
        });
    }
    /**
     * Download an analysis section as a PDF
     *
     * Renders one section of the IQ analysis report in headless Chromium and returns it as a single tall-page PDF (selectable text). `section` selects which section to render.
     */
    static downloadPdf(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/pdf',
            ...options
        });
    }
    /**
     * Bulk-import completed analyses
     *
     * Stores already-completed analyses verbatim (no LLM run). Intended for backfilling historical analyses. Idempotent on item id: existing ids are skipped. Returns a per-item result and counts. Admin-only, feature-flagged.
     */
    static importAnalyses(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Retry a failed analysis
     *
     * Creates a new analysis session using the same parameters as the failed one, deletes the original, and starts background analysis.
     */
    static retryAnalysis(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/retry',
            ...options
        });
    }
    /**
     * Build personas for the audiences this report suggested
     *
     * Starts enrichment for any suggested audience that is not ready yet, which also serves as the retry for ones that failed. Safe to call repeatedly: only one run is ever in flight, and a caller that arrives while one is running gets its current state.
     */
    static generateSuggestedAudiences(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/suggested-audiences/actions/generate',
            ...options
        });
    }
    /**
     * Put a suggested audience in the Knowledge Hub
     *
     * Creates the persona this audience was built into and records it on the report. Asking twice answers with the same persona rather than creating a second one.
     */
    static saveSuggestedAudience(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/suggested-audiences/{draftId}/actions/save',
            ...options
        });
    }
    /**
     * Build personas for the audiences this report was given as documents
     *
     * Same contract as the suggested-audience run, for the audiences read out of the documents the report was created with. Safe to call repeatedly: only one run is ever in flight, and a caller that arrives while one is running gets its current state.
     */
    static generateUploadedAudiences(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/uploaded-audiences/actions/generate',
            ...options
        });
    }
    /**
     * Put an audience read out of a document in the Knowledge Hub
     *
     * For an audience whose upload did not ask for it upfront. Asking twice answers with the same persona rather than creating a second one.
     */
    static saveUploadedAudience(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/uploaded-audiences/{draftId}/actions/save',
            ...options
        });
    }
    /**
     * Save an analysis as a workspace artifact
     *
     * Mints (idempotently) a context-less iq_analysis artifact for use in the project Library. All artifact fields are derived server-side from the analysis; the caller only supplies the analysis id. Used by "Save to project".
     */
    static saveAsArtifact(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/artifact',
            ...options
        });
    }
    /**
     * Upload a YouGov export (.xlsx or .csv) for an analysis
     *
     * Parses the uploaded YouGov brand-tracking export, computes the marketing-performance funnel and insights, and stores the result on the analysis. Requires the iq_yougov flag and the workspace to have activated YouGov as a data source. A source holds one file: uploading again replaces it.
     */
    static uploadYougov(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/yougov/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Upload a Pathmatics export (.xlsx or .csv) for an analysis
     *
     * Parses the uploaded Pathmatics advertising-spend export, aggregates the competitive media-spend and creative data, generates AI insights, and stores the result on the analysis (powering the Media Landscape and Creative Landscape views). Requires the iq_pathmatics flag and the workspace to have activated Pathmatics as a data source. A source holds one file: uploading again replaces it.
     */
    static uploadPathmatics(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/pathmatics/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Detach the YouGov data from an analysis
     *
     * Removes the parsed data and the stored file. The report keeps its own text.
     */
    static deleteYougov(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/yougov',
            ...options
        });
    }
    /**
     * Detach the Pathmatics data from an analysis
     *
     * Removes the parsed data and the stored file. The report keeps its own text.
     */
    static deletePathmatics(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/pathmatics',
            ...options
        });
    }
    /**
     * A short-lived download URL for the uploaded YouGov file
     *
     * Returns 404 for an analysis whose YouGov data was attached before uploads were stored.
     */
    static yougovFile(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/yougov/file',
            ...options
        });
    }
    /**
     * A short-lived download URL for the uploaded Pathmatics file
     *
     * Returns 404 for an analysis whose Pathmatics data was attached before uploads were stored.
     */
    static pathmaticsFile(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/pathmatics/file',
            ...options
        });
    }
    /**
     * Resolve an analysis id to its owning workspace and organization
     *
     * Accepts the analysis session id regardless of the selected workspace. Reveals organization identity only to members of that organization.
     */
    static resolveWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analysis/{id}/resolve-workspace',
            ...options
        });
    }
}
export class AudienceExtractionsService {
    /**
     * Read the audiences out of uploaded documents
     *
     * Starts reading the documents and answers immediately with the run to watch. Reading a deck takes longer than a request should wait, so the segments arrive on the run rather than in this response.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience-extractions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Where an extraction stands, and its segments once it is ready
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience-extractions/{id}',
            ...options
        });
    }
    /**
     * Read the same documents again
     *
     * For a run that failed or died mid-flight. A run somebody else is already holding is left alone, and a finished one answers with the segments it already has.
     */
    static retry(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audience-extractions/{id}/actions/retry',
            ...options
        });
    }
}
export class SpringboardCategoriesService {
    /**
     * Get springboard category customization for the current workspace
     *
     * Returns custom labels and descriptions when configured; otherwise hasCustomization is false. Uses the workspace from x-selected-workspace-id.
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/springboard/categories',
            ...options
        });
    }
    /**
     * Create or update springboard category customization for the current workspace
     *
     * Requires workspace admin permission and x-selected-workspace-id.
     */
    static upsert(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/springboard/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class SupportRequestsService {
    /**
     * File a support request with the support team
     *
     * Creates a ticket in the support queue on behalf of the caller. Reporter identity comes from the access token, not the body.
     */
    static create(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/support-requests',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Upload files to attach to a support request
     *
     * Holds the files for a request that is about to be filed. Pass the returned ids as attachmentIds when creating it.
     */
    static uploadAttachments(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/support-requests/attachments',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}
export class ExternalToolsService {
    /**
     * Get all external tools by scope
     */
    static get(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools',
            ...options
        });
    }
    /**
     * Create a new external tool
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get all categories by scope
     */
    static getAllCategories(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools/categories',
            ...options
        });
    }
    /**
     * Create a category
     */
    static createCategory(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a category
     */
    static deleteCategory(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools/categories/{categoryId}',
            ...options
        });
    }
    /**
     * Update a category
     */
    static updateCategory(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools/categories/{categoryId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete an external tool
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools/{id}',
            ...options
        });
    }
    /**
     * Update an existing external tool
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external-tools/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ContentTestsService {
    /**
     * Kick off a content-test run. Validates eligibility and transitions to `running` synchronously, then dispatches the runner in the background. Returns 202 with the test in `running` — FE polls for completion.
     */
    static run(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}/run',
            ...options
        });
    }
    /**
     * Generate a single image or video asset from a prompt for the setup-page Generate tab. Synchronous — the request blocks until the asset is produced or generation fails.
     */
    static generate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/generate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Save a content test as a workspace artifact
     *
     * Mints (idempotently) a context-less content_test artifact for use in the project Library. All artifact fields are derived server-side from the content test; the caller only supplies the content test id. Used by "Save to project".
     */
    static saveAsArtifact(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}/artifact',
            ...options
        });
    }
    /**
     * Download a content test as a PDF
     *
     * Renders the standalone content-test print page in headless Chromium and returns it as a single tall-page PDF (selectable text, clickable links). The render is scoped to the test's own workspace.
     */
    static downloadPdf(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}/pdf',
            ...options
        });
    }
}
export class GwiResearchService {
    /**
     * List a persona's GWI research Q&As for an entry point, most recent first
     */
    static history(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/gwi/personas/{personaId}/research-questions',
            ...options
        });
    }
    /**
     * Ask GWI a question about a persona and persist the Q&A
     */
    static ask(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/gwi/personas/{personaId}/research-questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete one of a persona's GWI research Q&As
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/gwi/personas/{personaId}/research-questions/{id}',
            ...options
        });
    }
}
export class AnalyticsService {
    /**
     * Distinct users active per day
     */
    static getActiveUsers(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analytics/active-users',
            ...options
        });
    }
    /**
     * Average session duration per day, in minutes
     */
    static getSessionDuration(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analytics/session-duration',
            ...options
        });
    }
    /**
     * Daily count for a single tracked product metric
     */
    static getEventMetric(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/analytics/metrics/{metricKey}',
            ...options
        });
    }
}
export class UrlUnfurlService {
    /**
     * Unfurl metadata for a web URL
     *
     * Fetches the page server-side and returns its declared metadata. An unreachable page still returns 200 with resolved=false and the hostname, so the caller renders a fallback rather than handling an error.
     */
    static unfurl(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/url-unfurl',
            ...options
        });
    }
}
export class AgentDefinitionsService {
    /**
     * List agent definitions
     */
    static list(options) {
        return (options?.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions',
            ...options
        });
    }
    /**
     * Create a draft agent definition
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get an agent definition with its draft
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}',
            ...options
        });
    }
    /**
     * Change scope or status (unpublish, archive, restore)
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Save the draft (optimistic concurrency on draftRevision)
     */
    static saveDraft(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Run the publish checks without publishing
     */
    static validate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/actions/validate',
            ...options
        });
    }
    /**
     * Version history, newest first
     */
    static listVersions(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/versions',
            ...options
        });
    }
    /**
     * Publish the draft (or an earlier version) as a new version
     */
    static publish(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/versions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get one published version
     */
    static getVersion(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/versions/{version}',
            ...options
        });
    }
    /**
     * Audit trail, oldest first
     */
    static audit(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/audit-events',
            ...options
        });
    }
    /**
     * List the agent's reference files
     */
    static listFiles(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/knowledge/files',
            ...options
        });
    }
    /**
     * Add reference files to the agent
     */
    static uploadFiles(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/knowledge/files',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Remove a reference file from the agent
     */
    static removeFile(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-definitions/{id}/knowledge/files/{fileId}',
            ...options
        });
    }
}
export class AgentBuildingBlocksService {
    /**
     * Tools, agents and MCP servers a flow in this scope may use
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-building-blocks',
            ...options
        });
    }
    /**
     * Models an agent node may name, with provider list prices
     */
    static models(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-building-blocks/models',
            ...options
        });
    }
    /**
     * Discover an MCP server's tools with the caller's own connection
     */
    static mcpTools(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/agent-building-blocks/mcp-servers/{id}/tools',
            ...options
        });
    }
}
export class WidgetRuntimesService {
    /**
     * Hands a runtime from before the JSON config block the config global it reads
     */
    static legacyConfig(options) {
        return (options?.client ?? client).get({ url: '/api/v1/widget-runtimes/legacy-config.js', ...options });
    }
    /**
     * A file of a widget runtime: host.js or styles.css
     */
    static file(options) {
        return (options.client ?? client).get({ url: '/api/v1/widget-runtimes/{hash}/{file}', ...options });
    }
}
export class WidgetsService {
    /**
     * What the browser measured after rendering a widget version
     *
     * The agent that made the widget reads it to fix overflow, empty values or broken charts.
     */
    static create(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/artifacts/{artifactId}/render-reports',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class WidgetDefinitionsService {
    /**
     * List widgets
     */
    static list(options) {
        return (options?.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions',
            ...options
        });
    }
    /**
     * Create a draft widget
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a widget no agent uses, with its versions
     */
    static remove(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}',
            ...options
        });
    }
    /**
     * Get a widget with its draft
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}',
            ...options
        });
    }
    /**
     * Rename, change scope, archive or restore
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Save the draft (optimistic concurrency on draftRevision)
     */
    static saveDraft(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Run the template checks publishing runs, without publishing
     */
    static check(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/actions/check',
            ...options
        });
    }
    /**
     * Copy a published version into the draft (optimistic concurrency on draftRevision)
     */
    static restoreVersion(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/actions/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Version history, newest first
     */
    static listVersions(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/versions',
            ...options
        });
    }
    /**
     * Publish the draft as a new version
     */
    static publish(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/versions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get one published version
     */
    static getVersion(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/versions/{version}',
            ...options
        });
    }
    /**
     * Audit trail, oldest first
     */
    static audit(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/audit-events',
            ...options
        });
    }
    /**
     * Store what the builder preview drew for a draft revision at one width and theme
     */
    static uploadPreview(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/previews',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * The latest light preview, as a PNG
     */
    static thumbnail(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/widget-definitions/{id}/thumbnail',
            ...options
        });
    }
}
